<template>
  <v-alert :class="{ 'alert--full-width': fullWidth }" :icon="icon" :type="variant" text>
    <Typography variant="body-2" :class="[messageColor, { 'alert__message--left': fullWidth }]">
      {{ message }}
    </Typography>
    <slot></slot>
  </v-alert>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
export default {
  components: {
    Typography,
  },
  name: "Alert",
  props: {
    variant: {
      type: String,
      default: "warning",

      validator: (value) => ["warning", "error", "info", "success"].includes(value),
    },
    message: {
      type: String,
      default: "",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      switch (this.variant) {
        case "warning":
          return "mdi-alert-outline";
        case "error":
          return "mdi-alert-circle-outline";
        case "success":
          return "mdi-check-circle-outline";
        default:
          return "mdi-information-outline";
      }
    },
    messageColor() {
      switch (this.variant) {
        case "warning":
          return "warningText--text";
        case "info":
          return "infoText--text";
        case "success":
          return "successText--text";
        case "error":
          return "errorText--text";
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped>
.v-alert.v-alert--text.error--text::before {
  background-color: var(--v-errorBackground-base);
  color: var(--v-error-base);
  opacity: 1;
}

.v-alert.v-alert--text.success--text::before {
  background-color: var(--v-successBackground-base);
  color: var(--v-success-base);
  opacity: 1;
}

.v-alert.v-alert--text.warning--text::before {
  background-color: var(--v-warningBackground-base);
  color: var(--v-warning-base);
  opacity: 1;
}

.v-alert.v-alert--text.info--text::before {
  background-color: var(--v-infoBackground-base);
  color: var(--v-info-base);
  opacity: 1;
}

/* That tint layer is absolutely positioned, so once it is opaque it paints over the
   static content. Lift the content back above it. */
.v-alert.v-alert--text ::v-deep .v-alert__wrapper {
  position: relative;
  z-index: 1;
}

.alert--full-width {
  width: 100%;
  margin: 0;
  justify-content: start;
}

.alert__message--left {
  width: 100%;
  text-align: left;
}
</style>
